import PropTypes from 'prop-types';
import Flux from '../../flux/Flux';
import { userType } from './FeedHelper';
import UrlBuilder from '../../utils/UrlBuilder';
import ReloadHelper from '../../utils/ReloadHelper';
import { getCommonTranslation } from '../../utils/TranslationHelper';
import FeedPostHeaderFavorite from './FeedPostHeaderFavorite';
import ActorAvatar from '../Actor/ActorAvatar';
import { PureComponent } from 'react';

class FeedPostHeader extends PureComponent {
	constructor(props) {
		super(props);

		this.onProfileClick = this.onProfileClick.bind(this);
		this.isMixedFeed = this.props.feedType !== Flux.Constants.Feed.FeedType.PROFILE;
	}

	isOnlineMobileVideocall() {
		const actorData = Flux.Actor.getActorData(this.props.model.id);
		return actorData?.isOnlineMobileVideocall;
	}

	onProfileClick(e) {
		if (this.props.feedType === Flux.Constants.Feed.FeedType.PROFILE) {
			e.preventDefault();
			return;
		}
		if (this.isMixedFeed) {
			Flux.Feed.setSelectedPostId(this.props.id, this.props.feedType);
			Flux.Feed.triggerSetPosts();
		}
		const route = UrlBuilder.buildActorProfileUrl(this.props.model.name);
		ReloadHelper.reload(route, e);
	}

	getName() {
		if (this.props.isRecommended) {
			return this.props.model.name;
		}

		return (
			<div className="feed-info__name-wrapper">
				<a
					className={'feed-info__name' + (this.isMixedFeed ? '' : ' feed-info__name--default')}
					href={UrlBuilder.buildActorProfileUrl(this.props.model.name)}
					onClick={this.onProfileClick}
				>
					{this.props.model.name}
				</a>
				{this.isMixedFeed && (
					<FeedPostHeaderFavorite
						actorId={parseInt(this.props.model.id)}
						isFavorite={this.props.guestState && this.props.guestState.following}
					/>
				)}
			</div>
		);
	}
	render() {
		const image = this.props.model.avatar ? this.props.model.avatar.url : 'https://www.visit-x.net/assets/img/navbar/guest_dummy.jpg';
		return (
			<div className={'feed-header' + (this.props.isRecommended ? ' feed-header--recommended' : '')}>
				<ActorAvatar
					linkVX={UrlBuilder.buildActorProfileUrl(this.props.model.name)}
					onClick={this.onProfileClick}
					imgUrl={image}
					actorName={this.props.model.name}
					isOnline={this.props.model.online}
					isOnlineMobileVideocall={this.props.model.onlineState === Flux.Constants.Feed.OnlineState.MOMENTUM}
					size={50}
				/>
				<div className="feed-info-container">
					<div className="feed-info">
						{this.getName()}
						{this.props.type === Flux.Constants.Feed.Types.PROFILE_IMAGE ? ' • ' + getCommonTranslation('new-profile-image') : ''}
						{this.props.type === Flux.Constants.Feed.Types.CONTEST ? ' • ' + getCommonTranslation('photo-contest') : ''}
					</div>
					{this.props.children}
				</div>
			</div>
		);
	}
}

FeedPostHeader.propTypes = {
	model: PropTypes.shape(userType),
	id: PropTypes.string,
	type: PropTypes.string,
	feedType: PropTypes.string,
	children: PropTypes.node,
	isRecommended: PropTypes.bool,
	initFavorite: PropTypes.bool,
	isMobile: PropTypes.bool,
	actorId: PropTypes.number,
	guestState: PropTypes.object,
};

export default FeedPostHeader;
